import { Component } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { setProject } from '@app/data/store/stage/stage.actions'
import { getProject } from '@app/data/store/stage/stage.selectors'
import { Store } from '@ngrx/store'
import { AppBasicPage } from '@page/app-basic.page'
import { Subscription } from 'rxjs'

@Component({
   selector: 'page-redirector',
   template: '',
})
export class RedirectorPage extends AppBasicPage {
   private _sub = new Subscription()

   constructor(
      private _route: ActivatedRoute,
      private _router: Router,
      private _store: Store
   ) {
      super()
   }

   ngOnInit(): void {
      if (this.console) console.log(this.logPrefix, 'init')

      this._sub.add(
         this._store.select(getProject).subscribe((proj) => {
            if (proj) {
               this._router.navigate(['/dashboard'])
            }
         })
      )

      this._route.queryParams.subscribe((params) => {
         if (params && params['id'] && !isNaN(params['id'])) {
            if (this.console) console.log(this.logPrefix, 'projectId: ' + params['id'])

            sessionStorage.setItem('currentProjectId', params['id'])

            this._store.dispatch(setProject({ projectId: params['id'] }))
         } else {
            this._router.navigate(['/error'])
         }
      })
   }

   ngOnDestroy(): void {
      this._sub.unsubscribe()
   }
}

